import { takeLatest, put, call, fork } from "redux-saga/effects";
import CibilService from "services/cibil-service";
import {
    fetchedCibilDetails,
    failedFetchCibilDetails,
    updatedCibilDetails,
    failedUpdateCibilDetails,
    createdCibilRequest,
    failedCreateCibilRequest,
    fetchCaseAssociates
} from "actions";

import { CIBIL_ACTIONS } from "constants/actions";
import { message } from "antd";

function* fetchCibilDetails({ payload }) {
    try {
        const {data, error} = yield call(
            CibilService.fetchCibilDetails,
            payload.requestType,
            payload.page,
            payload.page_size,
            payload.filters
        );
        if(!error) {
            yield put(fetchedCibilDetails(payload.requestType, payload.page, payload.page_size, data));
        } else {
            yield put(failedFetchCibilDetails(payload.requestType, payload.page, payload.page_size, error));
        }
    } catch (error) {
        yield put(failedFetchCibilDetails(payload.requestType, payload.page, payload.page_size, error));
    }
}

function* updateCibilDetails({ payload }) {
    try {
        const {data, error} = yield call(
            CibilService.updateCibilDetails,
            payload.data
        );
        if(!error) {
            yield put(updatedCibilDetails(payload.requestType, data));
        } else {
            yield put(failedUpdateCibilDetails(payload.requestType, error));
        }
    } catch (error) {
        yield put(failedUpdateCibilDetails(payload.requestType, error));
    }
}

function* createCibilRequest({ payload }) {
    try {
        const {data, error} = yield call(
            CibilService.createCibilRequest,
            payload.caseId,
            payload.associateId
        );

        if(!error) {
            message.success("CIBIL Request Created.");
            yield put(createdCibilRequest(payload.caseId, payload.associateId, data));
            yield put(fetchCaseAssociates(payload.caseId));
        } else {
            message.error("Failed to Request CIBIL.");
            yield put(failedCreateCibilRequest(payload.caseId, payload.associateId, error));
        }
    } catch(error) {
        if(error.non_field_errors && error.non_field_errors[0]) {
            message.error(error.non_field_errors[0]);
        } else {
            message.error("Failed to Request CIBIL.");
        }
        yield put(failedCreateCibilRequest(payload.caseId, payload.associateId, error));
    }
}

export default fork(function*() {
    yield takeLatest(CIBIL_ACTIONS.FETCH_CIBIL_DETAILS, fetchCibilDetails);
    yield takeLatest(CIBIL_ACTIONS.UPDATE_CIBIL_DETAILS, updateCibilDetails);
    yield takeLatest(CIBIL_ACTIONS.CIBIL_REQUEST, createCibilRequest);
});